// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5405":"21489d65","6452":"4083d25d","6850":"c095d196","6942":"22e93d05"}[chunkId] + ".chunk.css";
};